var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTool = function SvgTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.421 5.588c-.264-.264-.396-.396-.445-.549a.67.67 0 0 1 0-.412c.049-.152.181-.284.445-.548l1.892-1.892A4 4 0 0 0 6.78 6.784c.08.326.12.489.112.592a.6.6 0 0 1-.073.26c-.047.092-.138.183-.32.365l-4.166 4.166a1.414 1.414 0 0 0 2 2L8.5 10.002c.182-.183.273-.274.364-.321a.6.6 0 0 1 .262-.073c.103-.007.266.032.592.112q.457.112.95.113a4 4 0 0 0 3.646-5.646l-1.892 1.892c-.264.264-.396.396-.548.446a.67.67 0 0 1-.412 0c-.152-.05-.284-.182-.549-.446z"
  })));
};
export default SvgTool;